import { render } from "./CadastroProdutoDialog.vue?vue&type=template&id=55e81466&scoped=true"
import script from "./CadastroProdutoDialog.vue?vue&type=script&lang=js"
export * from "./CadastroProdutoDialog.vue?vue&type=script&lang=js"

import "./CadastroProdutoDialog.vue?vue&type=style&index=0&id=55e81466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e81466"]])

export default __exports__